export default __webpack_public_path__ + "static/LISA_P_WEB_BW-fbe2600b299d580b45f57864b1ecc711.jpg";